import { configureStore } from '@reduxjs/toolkit'
import hotelSlice from './features/hotelSlice'

const store = configureStore({
    reducer: {
        hotel: hotelSlice
    }
})

export default store